import * as React from 'react';
import { useState } from 'react';
import Modal from 'reactstrap/lib/Modal';
import ModalBody from 'reactstrap/lib/ModalBody';
import { Event } from '../../../../../api/Property';
import { addReservation, Reservation, updateReservation } from '../../../../../api/TourSignup';
import { formatDate } from '../../../../../utilities/formatting';
import { getTodaysDateString } from '../../../../../utilities/Utils';
import FormValidationDisplay from '../../../../common/form/ValidationDisplay';
import LoadingOverlay from '../../../../common/LoadingOverlay';
import * as moment from 'moment';
import Row from 'reactstrap/lib/Row';
import Col from 'reactstrap/lib/Col';
import Button from '../../../../common/form/Button';
import TourTimeSlotInput from '../../../../common/TourTimeSlotInput';

interface Props {
    isOpen: boolean;
    close: () => void;
    currentReservation: Reservation | undefined;
    propertyId: number;
    guestCardGuid: string;
    updateReservation: (reservation: Reservation) => void;
}

const ProspectUpdateTourTimePopup = (props: Props) => {
    const [isLoading, setIsLoading] = useState(false);
    const [errorMessage, setErrorMessage] = useState<string | undefined>(undefined);
    const [selectedTimeSlot, setSelectedTimeSlot] = useState<Event | undefined>(undefined);
    const [selectedDate, setSelectedDate] = useState(
        (props.currentReservation && formatDate(props.currentReservation.event.startDateTime)) ||
            getTodaysDateString()
    );

    const handleSubmit = async (timeSlot: Event) => {
        setIsLoading(true);

        let result;

        if (props.currentReservation) {
            result = await updateReservation(
                props.guestCardGuid,
                props.currentReservation.id,
                timeSlot
            );
        } else {
            result = await addReservation(props.guestCardGuid, timeSlot);
        }

        if (result.success && result.data) {
            setIsLoading(false);
            props.close();
            props.updateReservation(result.data);
        } else {
            setErrorMessage(result.error);
            setIsLoading(false);
        }
    };

    return (
        <Modal isOpen={props.isOpen}>
            <LoadingOverlay show={isLoading} inBootstrapColumn={false} />
            <FormValidationDisplay errorMessage={errorMessage} />

            <ModalBody>
                {props.currentReservation ? (
                    <div>
                        <p className="reschedule-popup-title">Update Reservation</p>
                        <p className="reschedule-help-text">
                            You currently have a reservation for the following date and time. To
                            reschedule, select a new date and time below.
                        </p>
                        <p className="reschedule-popup-tour-date">
                            {moment(props.currentReservation.event.startDateTime).format(
                                'MMMM DD, YYYY'
                            )}
                        </p>
                        <p>{`${moment(props.currentReservation.event.startDateTime).format(
                            'h:mm'
                        )} - ${moment(props.currentReservation.event.endDateTime).format(
                            'h:mm A'
                        )}`}</p>
                    </div>
                ) : (
                    <p className="reschedule-popup-title">Select Tour Time</p>
                )}

                <TourTimeSlotInput
                    event={selectedTimeSlot}
                    date={selectedDate}
                    propertyId={props.propertyId}
                    onDateChanged={setSelectedDate}
                    onTimeslotChanged={setSelectedTimeSlot}
                />
                <Row>
                    <Col className="update-field-modal-buttons">
                        <Button
                            text="Cancel"
                            onClick={() => props.close()}
                            suppressBottomMargin={true}
                        />
                        <Button
                            text={props.currentReservation ? 'Reschedule' : 'Schedule'}
                            onClick={() => {
                                if (selectedTimeSlot) {
                                    handleSubmit(selectedTimeSlot);
                                } else {
                                    setErrorMessage('Please select a timeslot');
                                }
                            }}
                            suppressBottomMargin={true}
                        />
                    </Col>
                </Row>
            </ModalBody>
        </Modal>
    );
};

export default ProspectUpdateTourTimePopup;



// WEBPACK FOOTER //
// ./src/components/pages/prospect/signup/confirmation/ProspectUpdateTourTimePopup.tsx